/* ==========================================================================
   SelectPanel > Client > input
   ========================================================================== */

/* Modules */
const { fromEvent } = require('rxjs');

const InputClient = require('@bluekiri/alexandria-contrib-components/components/input-rxjs/client/js');

const { actions, types } = require('../store/actions');
const { getUpdatedChoices } = require('../../../helpers');

const configuration = require('../config');

function initInput(instance) {
    const result = instance;
    const { config = {} } = instance;
    const { value: configValue } = config;

    /* Init input */
    result.input = InputClient(
        `${instance.selector} [data-component="InputRxjs"][data-type="${configuration().type.input}"]`
    );

    if (!result.input) return;

    /* Extends actions */
    result.actions = {
        ...result.actions,
        reset: () => result.store.dispatch(actions.reset(configValue)),
        toggleLoading: () => result.store.dispatch(actions.toggleLoading()),
        setError: () => result.store.dispatch(actions.setError()),
        resetStatus: () => result.store.dispatch(actions.resetStatus())
    };

    /* Extends reactions */
    result.reactions = {
        ...result.reactions,

        toggleLoading: result.store.subscribe((state, action) => {
            if (action.type !== types.TOGGLE_LOADING) return;

            /* Data */
            const { panel } = result.store.select('data');
            const { disabled } = result.input.store.select('input');

            if (result.input) result.input.actions.toggleLoading();

            /* Close panel */
            if (!disabled && panel) result.actions.closePanel();

            /* ensure disabled state */
            if (disabled) result.input.actions.disable();
        }),
        reset: result.store.subscribe((state, action) => {
            if (action.type !== types.RESET) return;
            /* Sync store value */
            result.actions.setValue(null);

            /* Data Store */
            const { items, value, panel } = result.store.select('data');

            /* Close panel */
            if (panel) result.actions.closePanel();

            /* Sync store options */
            result.actions.setOptions(getUpdatedChoices({ items, value }));

            /* Dispatch input reset */
            result.input.actions.reset();
        }),
        setError: result.store.subscribe((state, action) => {
            if (action.type !== types.SET_ERROR) return;

            result.input.actions.setError('');
        }),
        resetStatus: result.store.subscribe((state, action) => {
            if (action.type !== types.RESET_STATUS) return;

            result.input.actions.resetStatus('');
        })
    };

    /* extends subscriptions */
    result.subscriptions = {
        ...result.subscriptions,
        openPanel: fromEvent(result.input.hooks.input, 'click').subscribe(() => {
            /* Data */
            const { panel } = result.store.select('data');
            if (!panel) instance.actions.openPanel();
        })
    };
}

module.exports = {
    initInput
};
